module.exports = __webpack_public_path__ + "static/media/popup_no.2a1a0b0c.png";